/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import { createGlobalStyle } from 'styled-components';

/**
 * Estilização do componente MiniMapStyle
 */
export const MiniMapStyle = createGlobalStyle`
  .leaflet-control-minimap {
    display: block;
    border: solid rgba(255,255,255, 1) 2px;
    box-shadow: 0 2px 8px rgba(0,0,0, 0.3);
    background: #fff;
    margin-bottom: 8px !important;
    box-sizing: unset;
    bottom: 34px;
  }

  .retangulo-minimap {
    stroke-width: 3;
    fill: rgba(255,255,255, 0.3);
    stroke: #ff6f45;
  }

  .retangulo-minimap-shadow {
    stroke-width: 3;
    fill: #fff;
    stroke: #ff6f45;
  }

  .leaflet-control-minimap-toggle-display {
    background-image: url(${({ toogleIcon }) => toogleIcon}) !important;
    background-size: 12px !important;
    background-position: center;
  }

`;
